import { useState } from 'react';
import { MosyUser } from '../../lib/types';
import { AssigneeStack } from '../../lib/brandAvatars';
import AssigneePicker from './AssigneePicker';

interface Props {
  assignees: MosyUser[];
  team: MosyUser[];
  onChange: (ids: number[]) => void;
  size?: number;
  anchorRight?: boolean;
}

export const InlineAssignees = ({ assignees, team, onChange, size = 22, anchorRight }: Props) => {
  const [open, setOpen] = useState(false);
  const value = assignees.map((u) => u.user_id);
  return (
    <div style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
      <AssigneeStack users={assignees} size={size} onClick={() => setOpen((v) => !v)} />
      {open && (
        <AssigneePicker
          value={value}
          users={team}
          onChange={onChange}
          onClose={() => setOpen(false)}
          anchorRight={anchorRight}
        />
      )}
    </div>
  );
};

export default InlineAssignees;
